module.exports = __webpack_public_path__ + "static/assets/797c3df806ec50cd823c2e44d8671144.gif";